import PopularSearches from './popular-searches'

export default PopularSearches
